// Hard-stop политика (ADR-6): деньги, конфликты, ущерб, торг сверх лимита - всегда человек.
// Даже если модель решила ответить сама, сервер энфорсит эскалацию.

import type { Intent } from '../types/intent';

export const HARD_STOP_INTENTS = new Set<Intent>([
  'bargain',
  'complaint',
  'damage',
  'refund_cancel',
  'incident_noise',
  'incident_noise_neighbors',
]);

export const isHardStop = (intent: Intent): boolean => HARD_STOP_INTENTS.has(intent);
